module.exports = __webpack_public_path__ + "static/assets/9bdf4e70b102a156c5e3da161cb05f1e.png";